// Centralized config + sampling + caps.

export const SAMPLING = {
  event_sample_rate: 1.0,
  vitals_sample_rate: 1.0,
  error_sample_rate: 1.0,
  replay_sample_rate: 0.0, // Sprint 3
  schema_invalid_sample_rate: 0.01, // 1% of invalid events go to Sentry
} as const;

export const QUEUE = {
  pre_consent_max: 100,
  rate_limit_per_minute: 30,
  offline_max: 500,
  offline_ttl_ms: 7 * 24 * 60 * 60 * 1000, // 7d
  offline_namespace: "nr_analytics_queue_v1",
  retry_max: 3,
  retry_base_ms: 1000,
  retry_cap_ms: 30_000,
} as const;

export const SESSION = {
  ttl_ms: 30 * 60 * 1000, // 30 min idle
  storage_key: "nr_session_v1",
} as const;

export const UTM = {
  first_touch_key: "nr_first_touch_v1",
  last_touch_key: "nr_last_touch_v1",
  session_key: "nr_utm_session_v1",
  strip_params: ["fbclid", "gclid", "msclkid", "ttclid", "yclid", "twclid", "mc_cid", "mc_eid"],
  max_value_len: 200,
} as const;

export const CONSENT = {
  storage_key: "nr_consent_v1",
  // Bump policy_version (or copy) — hash will change → re-prompt automatic.
  policy_version: "2026-05-20",
  policy_copy_signature: "lgpd-banner-v1",
} as const;

export const ANONYMOUS_ID = {
  storage_key: "nr_anon_id_v1",
  rotation_ms: 13 * 30 * 24 * 60 * 60 * 1000, // ~13 months
  created_at_key: "nr_anon_id_created_v1",
} as const;
